import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropdownOption } from "./model/dropdown-option";
import { DropdownFooter } from "./model/dropdown-footer";
import { DropdownHeader } from "./model/dropdown-header";
import { inOutAnimation } from "../../animations";

@Component({
  selector: 'psc-dropdown',
  templateUrl: './dropdown.component.html',
  animations: [inOutAnimation({duration: 0.1})],
})
export class DropdownComponent {
  @Input() label: string = '';
  @Input() header: DropdownHeader;
  @Input() options: DropdownOption[] = [];
  @Input() footer: DropdownFooter;
  @Input() hideArrow: boolean = false;
  @Input() minOptionsWidthPx: number = 250;

  @Output() headerClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() optionClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() footerClicked: EventEmitter<void> = new EventEmitter<void>();

  listElementStyles = 'px-4 py-2 hover:bg-blue3 transition-colors ease-in-out hover:bg-opacity-20 flex gap-2';

  dropdownOpened: boolean = false;

}
